// extracted by mini-css-extract-plugin
module.exports = {"fixed-footer":"custom-menu-list__fixed-footer___2MJrW"};